var strings = {
  manageAppsAndSettings: 'Home'
};
export { strings };